var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeoliaImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.542,
    height: 42.542,
    viewBox: "0 0 42.542 42.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "veolia_logo",
    d: "M21.271,0A21.271,21.271,0,1,0,42.542,21.271,21.274,21.274,0,0,0,21.271,0m.1,33.436c2.614-2.92,5.241-6.912,4.553-10.176a4.677,4.677,0,0,0-9.335,0c-.689,3.265,1.938,7.256,4.553,10.176a15.175,15.175,0,1,1,.23,0",
    fill: "#ed1d24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeoliaImage);
export default __webpack_public_path__ + "static/media/veolia-image.4729d016eeca48ad80d0a2193a4c1f06.svg";
export { ForwardRef as ReactComponent };